// src/lib/clerkAppearance.ts
import type { Appearance } from '@clerk/types';

export const clerkAppearance: Appearance = {
  elements: {
    // ✅ ここを足す：モバイルでの水平ズレ潰し（Clerkの外枠をw-fullで固定）
    rootBox: 'w-full',
    cardBox: 'w-full mx-auto',
    card: 'w-full mx-auto shadow-none border-0 bg-transparent',
    main: 'w-full',

    logoBox: 'hidden',
    logoImage: 'hidden',

    headerTitle: 'hidden',
    headerSubtitle: 'hidden',

    // ★ 重複テキストの原因。これだけ追加
    footerAction: 'hidden',

    // ↓ ここ以下は現行の見栄えを完全に維持
    socialButtonsBlockButton: 'border rounded-lg',
    formButtonPrimary: 'bg-gray-900 hover:bg-gray-800',
  },
};
